// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"b69de0a5","476":"e8c7d933","763":"2bca2acb"}[chunkId] + ".chunk.js";
};